import {defineMessages} from 'react-intl';

export default defineMessages({
	color: {
		id: 'returnAuthCreateForm.step1.color',
		defaultMessage: 'Color:'
	},
	number: {
		id: 'returnAuthCreateForm.step1.number',
		defaultMessage: '№:'
	},
	size: {
		id: 'returnAuthCreateForm.step1.size',
		defaultMessage: 'Size:'
	},
	quantity: {
		id: 'returnAuthCreateForm.step1.quantity',
		defaultMessage: 'Quantity:'
	},
	total: {
		id: 'returnAuthCreateForm.step1.total',
		defaultMessage: 'Total:'
	},
	refundRequest: {
		id: 'returnAuthCreateForm.step2.refundRequest',
		defaultMessage: 'Refund request'
	},
	exchangeRequest: {
		id: 'returnAuthCreateForm.step2.exchangeRequest',
		defaultMessage: 'Exchange request'
	},
	reasonToReturn: {
		id: 'returnAuthCreateForm.step2.reasonToReturn',
		defaultMessage: 'Reason to return'
	},
});
